import Vue from 'vue';

export function getErroCotacaoMensagem(error: any): string {
  const status = error?.response?.status;
  let mensagem = 'Não foi possível concluir sua simulação. Tente novamente em instantes.';

  if (status >= 400 && status <= 499) {
    const responseData = error.response.data;
    if (typeof responseData === 'string') {
      mensagem = responseData;
    } else if (typeof responseData?.message === 'string') {
      mensagem = responseData.message;
    } else if (typeof responseData?.errors === 'string') {
      mensagem = responseData.errors;
    } else if (responseData?.errors && typeof responseData.errors === 'object') {
      mensagem = Object.values(responseData.errors).join(' ');
    }
  }

  return mensagem;
}

export function showErroCotacao(vm: Vue, error: any) {
  const mensagem = getErroCotacaoMensagem(error);

  let whatsappUrl = 'http://wa.me/554491056559';
  if (vm.$store.state.vendedor && vm.$store.state.vendedor.link) {
    whatsappUrl = vm.$store.state.vendedor.link;
  }

  return (vm as any).$swal({
    icon: 'error',
    title: 'Não foi possível concluir sua simulação',
    html: `${mensagem}<br><br>Se preferir, fale com nosso suporte pelo WhatsApp:<br>`
      + `<a href="${whatsappUrl}" target="_blank" rel="noopener">(44) 9105-6559</a>`,
  });
}
